export const JournalBannerSectionOne = () => {
  return null;
};
